import type { IconProps } from "@/types/IconProps";

export function Globe(props: IconProps) {
  const { size = 24, className, color = "currentColor", ...svgProps } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill={color}
      viewBox="0 0 24 24"
      className={className}
      {...svgProps}
    >
      <path d="M22.5 12c0-5.799-4.701-10.5-10.5-10.5S1.5 6.201 1.5 12 6.201 22.5 12 22.5V24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12v-1.5c5.799 0 10.5-4.701 10.5-10.5"></path>
      <g clipPath="url(#clip0_28_201)">
        <path d="M12 5a7 7 0 1 1 0 14 7 7 0 0 1 0-14m-5.447 7.75a5.5 5.5 0 0 0 3.699 4.464 9.8 9.8 0 0 1-1.47-4.464zm8.666 0a9.8 9.8 0 0 1-1.472 4.464 5.5 5.5 0 0 0 3.7-4.464zm-4.934 0A8.3 8.3 0 0 0 12 17.1a8.3 8.3 0 0 0 1.715-4.35zm3.462-5.965a9.8 9.8 0 0 1 1.472 4.465h2.228a5.5 5.5 0 0 0-3.7-4.465M12 6.898a8.3 8.3 0 0 0-1.715 4.352h3.43A8.3 8.3 0 0 0 12 6.898m-1.748-.113a5.5 5.5 0 0 0-3.7 4.465h2.23a9.8 9.8 0 0 1 1.47-4.465"></path>
      </g>
      <defs>
        <clipPath id="clip0_28_201">
          <path fill="#fff" d="M4.5 4.5h15v15h-15z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}
